import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
import { getScaledImageUri, ImageScale } from "@/helpers/image.helpers";
export enum ProfileBadgeSize {
  SMALL = "SMALL",
  MEDIUM = "MEDIUM",
  LARGE = "LARGE",
}
interface ProfileAvatarProps {
  readonly pfpUrl: string | null | undefined;
  readonly size?: ProfileBadgeSize | undefined;
  readonly alt?: string | undefined;
  readonly fallbackContent?: ReactNode | undefined;
}
const AVATAR_SIZE_CLASSES: Record<ProfileBadgeSize, string> = {
  [ProfileBadgeSize.SMALL]: "tw-h-7 tw-w-7",
  [ProfileBadgeSize.MEDIUM]: "tw-h-10 tw-w-10",
  [ProfileBadgeSize.LARGE]: "tw-h-12 tw-w-12"
};
export default function ProfileAvatar(t0) {
  const $ = _c(9);
  const {
    pfpUrl,
    size: t1,
    alt: t2,
    fallbackContent: t3
  } = t0;
  const size = t1 === undefined ? ProfileBadgeSize.MEDIUM : t1;
  const alt = t2 === undefined ? "Profile picture" : t2;
  const fallbackContent = t3 === undefined ? null : t3;
  const t4 = `${AVATAR_SIZE_CLASSES[size]} tw-bg-iron-900 tw-relative tw-flex-shrink-0 tw-rounded-lg`;
  let t5;
  if ($[0] !== alt || $[1] !== fallbackContent || $[2] !== pfpUrl) {
    t5 = pfpUrl ? <img src={getScaledImageUri(pfpUrl, ImageScale.W_AUTO_H_50)} alt={alt} className="tw-bg-transparent tw-max-w-full tw-max-h-full tw-h-auto tw-w-auto tw-mx-auto tw-object-contain" /> : fallbackContent;
    $[0] = alt;
    $[1] = fallbackContent;
    $[2] = pfpUrl;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== t5) {
    t6 = <div className="tw-rounded-lg tw-h-full tw-w-full"><div className="tw-ring-1 tw-ring-white/10 tw-h-full tw-w-full tw-max-w-full tw-rounded-lg tw-overflow-hidden tw-bg-iron-900"><div className="tw-h-full tw-text-center tw-flex tw-items-center tw-justify-center tw-rounded-lg tw-overflow-hidden">{t5}</div></div></div>;
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== t4 || $[7] !== t6) {
    t7 = <div className={t4}>{t6}</div>;
    $[6] = t4;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  return t7;
}